import BaseComponent from '../BaseComponent';

class InputCalendar extends BaseComponent {

	constructor(aElement) {

		super(aElement);

		this.attachEvents(aElement);
		
	}

	attachEvents(aElement) {

		let aEl = $(aElement);

		let min = aEl.data('min');
		let max = aEl.data('max');

		let searchRange = 30;

		let input = aEl.find('INPUT');
		let container = aEl.find('.calendar-content');

		let excludedDatesData = aEl.data('excluded-dates');
		let disableWeekEnds = aEl.data('disabled-week-end-days');


		input.on('keyup keydown keypress', (e) => {
			if (
				!isNaN(e.key)
				|| e.key == '.'
				|| e.keyCode == 8
				|| e.keyCode == 9
				|| e.keyCode == 46
				|| (e.keyCode >= 35 && e.keyCode <= 40) // Allow: home, end, left, right, down, up
				|| (e.keyCode == 65 && ( e.ctrlKey === true || e.metaKey === true ) ) // Allow: Ctrl+A, Command+A
			) {
				//accept
				let dateString = input.val();
				// check if entered value has 8 digits and is all int
				if (dateString.length == 8 && this.isIntOnly(dateString)) {
					// then format entered value as a valid date string and set the datepicker with the date
					let formattedDate = this.formatDate(input);
					input.datepicker("setDate", formattedDate);
				}

			} else {
				return false;
			}

		});

		input.on('change', (e) => {
			let dateString = input.val();
			if ((dateString.match(/./g) || []).length == 0 && dateString.length == 8 && this.isIntOnly(dateString)) {
				let formattedDate = this.formatDate(input);
				input.val(formattedDate);
			}
			else if ((dateString.match(/./g) || []).length > 0 && dateString.length == 10) {
				input.val(dateString);
			}
			input.datepicker('option', 'minDate', min);
			input.datepicker('option', 'maxDate', max);

		});

		// Options
		input.datepicker(
			{
				minDate: min,
				maxDate: max,
				dateFormat: 'dd.mm.yy',
				changeMonth: true,
				changeYear: true,
				constrainInput: false,
				firstDay: 1,

				beforeShow: (textbox, instance) => {

					aEl.addClass('active');

					let calendar = $('#ui-datepicker-div');

					container.append(calendar);

					calendar.show();

				},

				// Exclude holidays and week-ends
				beforeShowDay: (date) => {
					return this.openDay(date, aEl, excludedDatesData, disableWeekEnds, min, max);
				},

				onClose: () => {

					aEl.removeClass('active');

				}
			}
		).on("input change keyup keypress blur", (e) => {

			if (excludedDatesData || disableWeekEnds) {

				let dateString = input.val();
				let currentDate = dateString.split(/\s|\.|:/);
				let date = new Date(currentDate[2] + '-' + currentDate[1] + '-' + currentDate[0]);
				if (!this.openDay(date, aEl, excludedDatesData, disableWeekEnds, min, max)[0]) {
					this.searchAnotherDay(currentDate, searchRange, input, aEl, excludedDatesData, disableWeekEnds, min, max);
				}
				else {
				}

			}

		});
		
		input.on('change', (e) => {
			
			let reservationPdf = input.data('pdf-action');
			
			if(reservationPdf) {

				let pdfElement = input.closest('.snookfun-form').find('.reservation-pdf');
				let linkElement = pdfElement.find('a');
				let href = linkElement.attr('href');
				let inputVal = input.val();
				if (inputVal !== '') {
					href = href.replace(/#date=(\d){2}\.(\d){2}\.(\d){4}/gi, '');
					linkElement.attr('href', href + '#date=' + inputVal);
					pdfElement.show(250);
				}
				else {
					pdfElement.hide(250);
				}

			}
			
		});

		input.next('.calendar-icon').on('click', () => {
			input.focus();
		});

	}

	openDay(date, aEl, excludedDatesData, disableWeekEnds, min, max) {

		if (!excludedDatesData && !disableWeekEnds) {
			return [true, ''];
		}

		let excludedDates = [];
		if (excludedDatesData !== undefined) {
			excludedDates = excludedDatesData.split(',');
		}

		let minDateString = min.split(/\s|\.|:/);
		let minDate = new Date(minDateString[2] + '-' + minDateString[1] + '-' + (minDateString[0] - 1));

		let maxDateString = max.split(/\s|\.|:/);
		let maxDate = new Date(maxDateString[2] + '-' + maxDateString[1] + '-' + maxDateString[0]);

		if (date > maxDate) {
			return [false, ''];
		}
		else if (date < minDate) {
			return [false, ''];
		}
		else if (aEl.data('only-open-days') === true) {
			if ((disableWeekEnds) && (date.getDay() === 6 || date.getDay() === 0)) {
				return [false, ''];
			} else if ($.inArray($.datepicker.formatDate('d.m.yy', date), excludedDates) !== -1) {
				return [false, ''];
			} else {
				return [true, ''];
			}
		} else {
			return [true, ''];
		}
	}

	searchAnotherDay(currentDate, searchRange, input, aEl, excludedDatesData, disableWeekEnds, min, max) {
		let i = 0;
		// Search in the future
		while (i < searchRange) {
			let year = currentDate[2];
			let month = currentDate[1];
			let day = parseInt(currentDate[0]) + i; // In future...
			let newDate = new Date();
			newDate.setFullYear(parseInt(year), parseInt(month) - 1, parseInt(day));
			if (this.openDay(newDate, aEl, excludedDatesData, disableWeekEnds, min, max)[0]) {
				let newDay = newDate.getDate() < 10 ? '0' + newDate.getDate() : newDate.getDate();
				let newMonth = (newDate.getMonth() + 1) < 10 ? '0' + (newDate.getMonth() + 1) : (newDate.getMonth() + 1);
				input.val(newDay + '.' + newMonth + '.' + newDate.getFullYear());
				break;
			}
			i++;
		}
		// If nothing found, search in past
		if (i === searchRange) {
			i = 0;
			while (i < searchRange) {
				let year = currentDate[2];
				let month = currentDate[1];
				let day = parseInt(currentDate[0]) - i; // In past...
				let newDate = new Date();
				newDate.setFullYear(parseInt(year), parseInt(month) - 1, parseInt(day));
				if (this.openDay(newDate, aEl, excludedDatesData, disableWeekEnds, min, max)[0]) {
					let newDay = newDate.getDate() < 10 ? '0' + newDate.getDate() : newDate.getDate();
					let newMonth = (newDate.getMonth() + 1) < 10 ? '0' + (newDate.getMonth() + 1) : (newDate.getMonth() + 1);
					input.val(newDay + '.' + newMonth + '.' + newDate.getFullYear());
					break;
				}
				i++;
			}
		}
		// if nothing found in the future and in the past, take the min date by default
		if (i === searchRange) {
			input.datepicker("setDate", minDate);
		}
	}

	formatDate(input) {

		let day = input.val().substr(0, 2);
		let month = input.val().substr(2, 2);
		let year = input.val().substr(4, 4);

		if (parseInt(month) > 12) {
			month = 12;
		}
		if (parseInt(month) === '00') {
			month = '01';
		}

		if (month === '02') {
			if (day > 28) {
				if (day >= 29 && !(year % 4)) {
					day = 29;
				} else {
					day = 28;
				}
			}
		} else if (month === '04' || month === '06' || month === '09' || month === '11') {
			if (day > 30) {
				day = 30
			}
		} else {
			if (day > 31) {
				day = 31
			}
		}

		if (day === '00') {
			day = '01';
		}

		let formattedDate = day + '.' + month + '.' + year;

		return formattedDate;

	}

	isIntOnly(dateString) {

		let intRegex = /^\d+$/;

		return intRegex.test(dateString)

	}

}

export default InputCalendar;